<template>
  <div class="userParallelConnection-container">
    <div class="title-content" style="display: flex;justify-content: space-between;align-items: center;">
      <div>{{ h_i18n('beb78b132a28c880f959eba2b94ef5e4') }}{{ $route.query.vName }}</div>
      <!-- <h-button-new type="primary" @click="handleVersion" size="middle">切换旧版</h-button-new> -->
    </div>
    <h-list-page-new class="connection-container">
      <div class="item-module" style="margin-top: 6px;">
        <div class="left-module">
          <div class="title-style">{{ h_i18n('4d7b168a15760baadbbb7385577f6f83') }}</div>
          <!-- <div class="unit-style">单位</div> -->
          <div class="module-content" v-if="pieData&&pieData!=null&&pieData!=''&&pieData!=undefined">
            <performancePie v-model:pieData="pieData"></performancePie>
          </div>
        </div>
        <div class="right-module">
          <div class="item-count">
            <div class="right-num-title">{{ h_i18n('a94af728555f1e79ba8993149a550a15') }}<span class="bottom-line"></span></div>
            <div class="item-num">
              <div class="num-content">
                <div class="num">{{yhpjtop.ghlday || ''}}</div>
                <div class="num-label">{{ h_i18n('39f3471d6d7490e532451735a007c7b9') }}</div>
              </div>
              <div class="num-content">
                <div class="num">{{yhpjtop.ghlmonth || ''}}</div>
                <div class="num-label">{{ h_i18n('8d9f49f7ca71bebe79884bff4c1d1564') }}</div>
              </div>
              <div class="num-content">
                <div class="num">{{yhpjtop.ghlyear || ''}}</div>
                <div class="num-label">{{ h_i18n('dd854a16dcdf535f42974dec3143db43') }}</div>
              </div>
            </div>
          </div>
          <div class="item-count marginT12">
            <div class="right-num-title">{{ h_i18n('192da253760c41cbab573083fc3c7d5d') }}<span class="bottom-line2"></span></div>
            <div class="item-num">
              <div class="num-content">
                <div class="num">{{yhpjtop.xcblday}}</div>
                <div class="num-label">{{ h_i18n('39f3471d6d7490e532451735a007c7b9') }}</div>
              </div>
              <div class="num-content">
                <div class="num">{{yhpjtop.xcblmonth}}</div>
                <div class="num-label">{{ h_i18n('8d9f49f7ca71bebe79884bff4c1d1564') }}</div>
              </div>
              <div class="num-content">
                <div class="num">{{yhpjtop.xcblyear}}</div>
                <div class="num-label">{{ h_i18n('dd854a16dcdf535f42974dec3143db43') }}</div>
              </div>
            </div>
          </div>
          <div class="item-count marginT12">
            <div class="right-num-title">{{ h_i18n('3dca46482e8752bb1ef932640a0d65a4') }}<span class="bottom-line3"></span></div>
            <div class="item-num">
              <div class="num-content">
                <div class="num">{{yhpjtop.scblday}}</div>
                <div class="num-label">{{ h_i18n('39f3471d6d7490e532451735a007c7b9') }}</div>
              </div>
              <div class="num-content">
                <div class="num">{{yhpjtop.scblmonth}}</div>
                <div class="num-label">{{ h_i18n('8d9f49f7ca71bebe79884bff4c1d1564') }}</div>
              </div>
              <div class="num-content">
                <div class="num">{{yhpjtop.scblyear}}</div>
                <div class="num-label">{{ h_i18n('dd854a16dcdf535f42974dec3143db43') }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="item-module">
        <div class="left-module" id="badSceneContent">
          <div class="flex-between" style="align-items: flex-start;">
            <div class="title-style">{{ h_i18n('192da253760c41cbab573083fc3c7d5d') }}</div>
            <div class="tabs">
              <div class="tab-item" :class="currentScene=='day'?'selected':''" @click="handleScence('day')">{{ h_i18n('3edddd85ac2c5e612fb71dbb89e7d1c5') }}</div>
              <div class="tab-item" :class="currentScene=='month'?'selected':''" @click="handleScence('month')">{{ h_i18n('e42b99d59954ce6437e66f416850425a') }}</div>
            </div>
          </div>
          <div class="flex-between marginT12" style="align-items: center;">
            <div class="unit-style" style="margin-top: 0;">{{ h_i18n('ace5195cd1a188320f504df8b7e0056f') }}</div>
            <div class="legend-text"><span class="blue-circle"></span>{{ h_i18n('bf66939262f6f1c16b9c2a3b6ba5dfd0') }}</div>
          </div>
          <div class="module-content" v-if="ySceneData&&ySceneData.length>0">
            <badSceneLine :lineWidth="lineWidth" :lineHeight="lineHeight" :xData="xSceneData" :yData="ySceneData"></badSceneLine>
          </div>
        </div>
        <div class="right-module">
          <div class="flex-between" style="align-items: flex-start;">
            <div class="title-style">{{ h_i18n('3dca46482e8752bb1ef932640a0d65a4') }}</div>
            <div class="tabs">
              <div class="tab-item" :class="currentMarket=='day'?'selected':''" @click="handleMarket('day')">{{ h_i18n('3edddd85ac2c5e612fb71dbb89e7d1c5') }}</div>
              <div class="tab-item" :class="currentMarket=='month'?'selected':''" @click="handleMarket('month')">{{ h_i18n('e42b99d59954ce6437e66f416850425a') }}</div>
            </div>
          </div>
          <div class="flex-between marginT12" style="align-items: center;">
            <div class="unit-style" style="margin-top: 0;">{{ h_i18n('ace5195cd1a188320f504df8b7e0056f') }}</div>
            <div class="legend-text"><span class="market-circle"></span>{{ h_i18n('d6e624b488ee0bca49b08e8649ff5bee') }}</div>
          </div>
          <div class="module-content" v-if="yMarketData&&yMarketData.length>0">
            <badMarketLine :lineWidth="lineWidth" :lineHeight="lineHeight" :xData="xMarketData" :yData="yMarketData"></badMarketLine>
          </div>
        </div>
      </div>
      <div class="item-module1">
        <div class="title-style">{{ h_i18n('e141b07b4aa6311b8dbb2b2ffbc03dda') }}</div>
        <div class="filter-content">
          <h-search :title="h_i18n('19fcb9eb2594059036dfede5f4ec53e8')">
            <h-date-picker-new type="daterange" v-model="searchTime" range-separator="-"
                  :start-placeholder="h_i18n('a3e3b88377c8a2f34e0f9ef6e67dbe62')" :end-placeholder="h_i18n('12f1d7ef38af6326c94fd11688f5b453')" clearable></h-date-picker-new>
          </h-search>
          <div class="primary-btn marginL12" @click="getMainBotData">{{ h_i18n('e5f71fc31e7246dd6ccc5539570471b0') }}</div>
          <div class="reset-btn" @click="resetTable">{{ h_i18n('4b9c3271dc2f299dc3aeffb369187513') }}</div>
        </div>
        <div class="export-btn">
          <div @click="handleExport">
            <img src="@/assets/img/export.png" style="width: 16px;height: 16px;position: relative;top: 3px;right: 5px;"/>{{ h_i18n('c7f0d5d1755a82916ddbbc52cfd4918e') }}</div>
        </div>
        <el-table :empty-text="h_i18n('21efd88b67a39834582ad99aabb9dc60')" height="500" class="myTable"
          :data="badTableData" size="small" style="font-size:14px;width: 100%; min-height: 500px;border-radius: 8px;border-color:#E5E6EB !important;border:1px solid #E5E6EB;border-bottom: none;" :header-cell-style="{ background: '#f1f2f8 !important' , color: '#1D2129' }">
          <el-table-column prop="reportat" :label="h_i18n('4ff1e74e43a3586339251494117185ad')" width="110"></el-table-column>
          <el-table-column :label="h_i18n('26ca20b161c33362d88eb0ba0bc90751')">
            <template #default="{ row }">
              <span>{{ h_i18n('fe66e18c42d46d52ea898226aa9390d8') }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="username" :label="h_i18n('1fd02a90c38333badc226309fea6fecb')"></el-table-column>
          <el-table-column prop="plname" :label="h_i18n('ebb4b1e6b91d291d055017ecb158011b')"></el-table-column>
          <el-table-column prop="protype" :label="h_i18n('ac4190dfda1d11d558c1d44d0f6697a3')"></el-table-column>
          <el-table-column prop="badmod" :label="h_i18n('d5c683084117895d15e463f60b3540bf')"></el-table-column>
          <el-table-column prop="badper" :label="h_i18n('10d3b8f8e260d4e9cd4fe33169dfae62')"></el-table-column>
          <el-table-column prop="jhsta" :label="h_i18n('e3d41c21207f58954b4a237a94e9fd54')">
            <template #default="{ row }">
              <!-- jhsta 1:未交互；2:交互中；3:拖期 -->
              <span class="status1" v-show="row.jhsta==1">{{ h_i18n('1a88ac0ce7cda47b71f0703ade4b6d23') }}</span>
              <span class="status2" v-show="row.jhsta==2">{{ h_i18n('ce470d57ea7508bf969b5d7f94a346f4') }}</span>
              <span class="status3" v-show="row.jhsta==3">{{ h_i18n('e87d947355e343245273e6cecce2adaf') }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="h_i18n('2b6bc0f293f5ca01b006206c2535ccbc')" width="60">
            <template #default="{ row }">
              <span class="click-btn" @click="handleCheck(row)">{{ h_i18n('607e7a4f377fa66b0b28ce318aab841f') }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="item-module1">
        <div class="title-style">{{ h_i18n('e9a8d7dc794a8ea0f27c13b47316ce83') }}</div>
        <el-table :empty-text="h_i18n('21efd88b67a39834582ad99aabb9dc60')" height="500" class="myTable"
          :data="marketTableData" size="small" style="font-size:14px;width: 100%; min-height: 500px;border-radius: 8px;border:1px solid #E5E6EB;border-bottom: none;border-color:#E5E6EB !important;margin-top: 12px;"
          :header-cell-style="{ background: '#f1f2f8 !important' , color: '#1D2129' }">
          <el-table-column prop="reportat" :label="h_i18n('4ff1e74e43a3586339251494117185ad')" width="120" style="padding-left: 16px"></el-table-column>
          <el-table-column :label="h_i18n('26ca20b161c33362d88eb0ba0bc90751')">
            <template #default="{ row }">
              <span>{{ h_i18n('fe66e18c42d46d52ea898226aa9390d8') }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="username" :label="h_i18n('1fd02a90c38333badc226309fea6fecb')"></el-table-column>
          <el-table-column prop="plname" :label="h_i18n('ebb4b1e6b91d291d055017ecb158011b')"></el-table-column>
          <el-table-column prop="protype" :label="h_i18n('ac4190dfda1d11d558c1d44d0f6697a3')"></el-table-column>
          <el-table-column prop="badmod" :label="h_i18n('d5c683084117895d15e463f60b3540bf')"></el-table-column>
          <el-table-column prop="badper" :label="h_i18n('10d3b8f8e260d4e9cd4fe33169dfae62')"></el-table-column>
          <el-table-column :label="h_i18n('e3d41c21207f58954b4a237a94e9fd54')">
            <template #default="{ row }">
              <span class="status4" v-show="row.jhsta==4">{{ h_i18n('2604650cae56276ebfcd86b49a8f5b66') }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="h_i18n('2b6bc0f293f5ca01b006206c2535ccbc')" width="60">
            <template #default="{ row }">
              <span class="click-btn" @click="handleDetail(row)">{{ h_i18n('607e7a4f377fa66b0b28ce318aab841f') }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </h-list-page-new>
  </div>
</template>

<script>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

import performancePie from './components/performancePie'
import badSceneLine from './components/badSceneLine'
import badMarketLine from './components/badMarketLine'
import moment from 'moment'

export default {
  data(){
    return{
      pieData:null,
      searchData:{},
      searchTime:[],
      infoList:[{
        label:h_i18n('5993e2fa495bbfe164008c9dd3203f16'),
        value:h_i18n('5993e2fa495bbfe164008c9dd3203f16')
      },{
        label:h_i18n('3dca46482e8752bb1ef932640a0d65a4'),
        value:h_i18n('3dca46482e8752bb1ef932640a0d65a4')
      },{
        label:h_i18n('ce6dffd32bfbab7acc43b848666cd5e7'),
        value:h_i18n('ce6dffd32bfbab7acc43b848666cd5e7')
      },{
        label:h_i18n('53bf5360c96fa312a0da834237db369a'),
        value:h_i18n('53bf5360c96fa312a0da834237db369a')
      },{
        label:h_i18n('192da253760c41cbab573083fc3c7d5d'),
        value:h_i18n('192da253760c41cbab573083fc3c7d5d')
      }],
      performanceData:[{
        textName:h_i18n('a94af728555f1e79ba8993149a550a15')
      },{
        textName:h_i18n('192da253760c41cbab573083fc3c7d5d')
      },{
        textName:h_i18n('3dca46482e8752bb1ef932640a0d65a4')
      }],
      lineWidth:'',
      lineHeight:420,
      badTableData: [],
      marketTableData:[],
      marketCurrentPage:1,
      marketTotal:0,
      yhpjtop:{}, // 右上角供货量
      xSceneData:[],
      ySceneData:[],
      xMarketData:[],
      yMarketData:[],
      currentScene: 'day',
      currentMarket: 'day',
      midEchartData:{}
    }
  },
  components:{
    performancePie,badSceneLine,badMarketLine
  },
  methods:{
    h_i18n,
    handleCheck(row){
      this.$router.push({name:"userComplaintDetail",query:{gdcode:row.gdcode,vcode: this.$route.query.vcode||this.$route.query.vCode,searchTime:this.searchTime}})
    },
    handleDetail(row){
      console.log('this.searchTime===============',this.searchTime)
      this.$router.push({name:"userComplaintDetail",query:{gdcode:row.gdcode,vcode: this.$route.query.vcode||this.$route.query.vCode,searchTime:this.searchTime,isDetail: true}})
    },
    getMainTopMethods(){
      this.startLoading(h_i18n('26b5bd4947df8be257c59dde927b400c'))
      this.$http({
        method: "post",
        url: `/base/userevaluation/getMainTop?vcode=${this.$route.query.vcode||this.$route.query.vCode}`,
      }).then((res) => {
        this.closeLoading()
        if(res&&res.data&&res.data.code==0){
          this.yhpjtop = res.data.data.yhpjtop || {}
        }
      }).catch(err=>{
        this.closeLoading()
        this.info(err.data.msg)
      })
    },
    // 查询
    getScoreData(){
      this.startLoading(h_i18n('26b5bd4947df8be257c59dde927b400c'))
      this.$http({
        method: "post",
        url: `/base/userevaluation/getScore?vcode=${this.$route.query.vcode||this.$route.query.vCode}`,
      }).then((res) => {
       this.$nextTick(()=>{
        this.pieData = res.data.data
        this.closeLoading()
       })
      }).catch(err=>{
        this.closeLoading()
        this.info(err.data.msg)
      })
    },
    resetTable(){
      this.searchData = {}
      this.searchTime = []  
    },
    // 查询底部列表
    getMainBotData(){
      if(this.searchData.source=='现场不良'){
        this.info(h_i18n('e882d4b6032134d29a0ffe19495e0dfc'))
        return false
      }
      if(this.searchData.source=='重大质量问题'){
        this.info(h_i18n('69351cdb904adcdc67ce2e68aedbbbf5'))
        return false
      }
      this.startLoading(h_i18n('26b5bd4947df8be257c59dde927b400c'))
      let params = {...this.searchData}
      if(this.searchTime&&this.searchTime.length>0){
        params.start = moment(this.searchTime[0]).format("YYYY-MM-DD")
        params.end = moment(this.searchTime[1]).format("YYYY-MM-DD")
      }
      this.$http({
        method: "post",
        url: `/base/userevaluation/getMainBotSele`,
        data:{
          vcode:this.$route.query.vcode || this.$route.query.vCode,
          ...params
        }
      }).then((res) => {
       this.$nextTick(()=>{
        if(res.data.code == 0){
          this.badTableData = res.data.data.mblist||[]
          this.marketTableData = res.data.data.mbcloselist||[]
          this.closeLoading()
        }
       })
      }).catch(err=>{
        this.closeLoading()
        this.info(err.data.msg)
      })
    },
    getMainMidData(){
      this.startLoading(h_i18n('26b5bd4947df8be257c59dde927b400c'))
      this.$http({
        method: "post",
        url: `/base/userevaluation/getMainMid?vcode=${this.$route.query.supplyCode||this.$route.query.vCode||this.$route.query.vcode}`,
      }).then((res) => {
       this.$nextTick(()=>{
          this.ySceneData = res.data.data.chart1 || []
          this.yMarketData = res.data.data.chart5 || []
          this.midEchartData = res.data.data || {}
          let length = this.ySceneData&&this.ySceneData.length||0
          this.xSceneData = this.generateArray(length)
          this.xMarketData = this.generateArray(length)
        //   const monthsArray = this.getMonthsArray();
        // console.log(monthsArray); // 输出从1月到当前月的数组
        // console.log('44324324000000',this.generateArray(31)); // 输出: [1, 2, 3, 4, 5]
          this.closeLoading()
        })
      }).catch(err=>{
        this.closeLoading()
        this.info(err.data.msg)
      })
    },
    handleScence(val){
      this.currentScene = val
      this.ySceneData = this.midEchartData.chart2
      let length = this.ySceneData&&this.ySceneData.length
      this.xSceneData = this.getMonthsArray(length)
      this.xMarketData = this.getMonthsArray(length)
      console.log('this.ySceneData',this.ySceneData)
    },
    handleMarket(val){
      this.currentMarket = val
      this.yMarketData = this.midEchartData.chart6
      let length = this.yMarketData&&this.yMarketData.length
      this.xSceneData = this.getMonthsArray(length)
      this.xMarketData = this.getMonthsArray(length)
      console.log('this.yMarketData',this.yMarketData)
    },
    // 导出
    handleExport(){
      this.startLoading(h_i18n('a80f42999229739c9eb9725ffa9adbfd'));
      let params = {...this.searchData}
      if(this.searchTime&&this.searchTime.length>0){
        params.start = moment(this.searchTime[0]).format("YYYY-MM-DD")
        params.end = moment(this.searchTime[1]).format("YYYY-MM-DD")
      }
      this.httpFile(
        {
          method: "post",
          url: "/base/userevaluation/marketbadexport",
          data: {
            vcode:this.$route.query.vcode || 'V12970',
            ...params
          },
        },
        h_i18n('71cca85b2825e67a961ff16bdcd5e329')
      ).then(res=>{
        console.log('res',res)
        this.closeLoading();
      }).catch(err=>{
        console.log('err',err)
        this.closeLoading()
      })
    },
    getMonthsArray () {
      const currentMonth = new Date().getMonth() + 1; // 获取当前月份，从0开始
      return Array.from({ length: currentMonth }, (_, index) => index + 1);
    },
    generateArray(n) {
      return Array.from({ length: n }, (_, i) => i + 1);
    },
    handleVersion(){
      const vCode = this.$route.query.vcode
      const vName = this.$route.query.vName
      const resourceId = this.$route.query.resourceId
      if (process.env.NODE_ENV != 'production') {
        window.open("https://t-api-cn-sp000339-bridge-i.hwork.haier.net/userevaluation?vcode="+ vCode+"&vName="+vName+"&resourceId="+resourceId)
      }else{
        window.open("https://sqm.haier.net/userevaluation?vcode="+ vCode+"&vName="+vName+"&resourceId="+resourceId)
      }
    }
  },
  created(){
    if(this.$route.query.searchTime&&this.$route.query.searchTime.length>0){
      this.searchTime = this.$route.query.searchTime
    }else{
      this.searchTime = [moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'),moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')]
    }
    
    this.$nextTick(()=>{
      // let tmp = document.getElementById('badSceneContent')
      let tmp = Number(window.innerWidth)/2 - 84
      this.lineWidth = tmp
    })
    
    this.getScoreData()
    this.getMainTopMethods()
    this.getMainBotData()
    this.getMainMidData()
  },
}
</script>

<style>
  .el-table--border td:first-child .cell, .el-table--border th:first-child .cell{
    padding-left: 140px;
  }
/* .h-box .h-box-title{
  color: #1D2129 !important;
}
.el-date-editor .el-range-input{
  text-align: left !important;
  color: #1D2129;
}
.el-range-editor .el-range-input{
  text-align: left !important;
}
.is-hwork .haier-input-4 .el-input__inner{
  padding-left: 80px ;
}
.el-input__icon{
  width: 16px;
}
.el-date-editor .el-range__icon{
  margin-left: -10px;
}
.haier-list-page .el-input__inner{
  color: #1D2129;
}
 */
/* .el-select-dropdown__list{
  padding: 6px 8px;
}
.el-select .el-input.is-focus .el-input__inner{
  border: 1px solid#165DFF;
}
.el-select-dropdown__item.hover, .el-select-dropdown__item:hover{
  box-sizing: border-box;
  background: #F1F2F8;
  border-radius: 6px;
}
.el-range-editor.is-active, .el-range-editor.is-active:hover{
  border: 1px solid#165DFF;
} */
.is-hwork .el-input--prefix:not(.w512) .el-input__inner{
  color: #1D2129;
}
body .el-table .cell{
  text-align: left;
  padding-left: 16px;
}
</style>

<style lang="scss" scoped>
.is-hwork{
  width: 100%;
  min-width: 100%;
  box-sizing: border-box;
}
.is-hwork .el-table th{
  background: #F1F2F8 !important;
  color: #1D2129 !important;
  font-size: 14px;
}
.haier-list-page .el-table--border, .haier-list-page .haier-list-page .el-table--group{
  border-right: none;
  border-bottom: none;
}

</style>

<style lang="scss" scoped>
.title-content{
  box-sizing: border-box;
  background: #fff;
  height: 56px;
  line-height: 56px;
  color: #1D2129;
  font-size: 18px;
  padding: 0 16px;
}
.marginT12{
  margin-top: 12px;
}
.flex-between{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .tabs{
    box-sizing: border-box;
    background: #F2F3F5;
    width: 68px;
    height: 28px;
    line-height: 22px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border-radius: 4px;
    padding: 3px;
  }
  .tab-item{
    width: 28px;
    height: 22px;
    line-height: 22px;
    border-radius: 4px;
    text-align: center;
    cursor: pointer;
    font-size: 12px;
  }
  .selected{
    display: inline-block;
    background: #fff;
    font-size: 12px;
    color: #165dff;
  }
  .blue-circle{
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 6px;
    background: #165dff;
    margin-right: 5px;
  }
  .market-circle{
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 6px;
    background: #FF5500;
    margin-right: 5px;
  }
  .legend-text{
    font-size: 12px;
    color: #1D2129;
    display: flex;
    align-items: center;
  }
}
.status1{
  display: inline-block;
  width: 52px;
  height: 20px;
  line-height: 20px;
  border-radius: 4px;
  background: #EDEFF2;
  color: #4E5969;
  font-size: 12px;
  text-align: center;
}
.status2{
  display: inline-block;
  width: 52px;
  height: 20px;
  line-height: 20px;
  border-radius: 4px;
  background: #E8F3FF;
  color: #165DFF;
  font-size: 12px;
  text-align: center;
}
.status3{
  display: inline-block;
  width: 52px;
  height: 20px;
  line-height: 20px;
  border-radius: 4px;
  background: #FFF7E8;
  color: #FF7D00;
  font-size: 12px;
  text-align: center;
}
.status4{
  display: inline-block;
  width: 52px;
  height: 20px;
  line-height: 20px;
  border-radius: 4px;
  background: #E6FFEC;
  color: #00C853;
  font-size: 12px;
  text-align: center;
}
.connection-container{
  // background: #fff;

  .title-style{
    font-size: 14px;
    color: #1D2129;
    font-weight: bold;
  }
  .item-module{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 12px;

    .unit-style{
      color: #4E5969;
      font-size: 12px;
      margin-top: 16px;
    }
    .left-module{
      width: calc(50% - 6px);
      border-radius: 8px;
      background: #fff;
      margin-right: 12px;
      padding: 16px;
    }
    .right-module{
      width: calc(50% - 6px);
      border-radius: 8px;
      background: #fff;
      // margin-left: 6px;
      padding: 16px;
      .item-count{
        box-sizing: border-box;
        padding: 16px;
        width: 100%;
        background-image: radial-gradient(circle at center,hsl(0, 0%, 100%),#E7EEFC);
        border-radius: 8px;
        border: 2px solid #fff;
        .right-num-title{
          font-weight: bold;
          font-size: 14px;
          color: #333;
          .bottom-line{
            display: inline-block;
            width: 72px;
            height: 6px;
            background: linear-gradient(to right, rgba(22, 93, 255, 0.5), rgba(22, 93, 255, 0));
            position: relative;
            top: 4px;
            left: -42px;
          }
          .bottom-line2{
            display: inline-block;
            width: 72px;
            height: 6px;
            background: linear-gradient(to right, rgba(22, 93, 255, 0.5), rgba(22, 93, 255, 0));
            position: relative;
            top: 4px;
            left: -57px;
          }
          .bottom-line3{
            display: inline-block;
            width: 72px;
            height: 6px;
            background: linear-gradient(to right, rgba(22, 93, 255, 0.5), rgba(22, 93, 255, 0));
            position: relative;
            top: 4px;
            left: -56px;
          }
        }
        .item-num{
          display: flex;
          flex-direction: row;
          justify-content: space-around;
          margin-top: 20px;
          .num-content{
            text-align: center;
            width: 33.33%;
            .num{
              font-size: 20px;
              color: #1D2129;
              font-weight: bold;
            }
            .num-label{
              color: #4E5969;
              font-size: 14px;
            }
          }
        }
      }
    }
    .module-content{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
  }
  .item-module1{
    margin-top: 12px;
    width: 98%;
    border-radius: 8px;
    background: #fff;
    margin-right: 6px;
    padding: 16px;
    min-height: 417px;
    .filter-content{
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      margin-top: 16px;
    }
  }
  .primary-btn{
    display: inline-block;
    min-width: 60px;
    max-width: 80px;
    height: 30px !important;
    line-height: 30px !important;
    text-align: center;
    background: #fff;
    border: 1px	solid#165DFF;
    color: #165dff;
    border-radius: 6px;
    font-size: 14px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-left: 8px;
    &:hover{
      background: rgba(22, 93, 255, 0.1);
    }
    &:active{
      color: #0E42D2;
      background: rgba(14, 66, 210, 0.1);
      border: 1px	solid rgb(14, 66, 210);
    }
  }
  .reset-btn{
    display: inline-block;
    width: 60px;
    height: 30px !important;
    line-height: 30px !important;
    text-align: center;
    background: #fff;
    border: 1px	solid#C9CDD4;
    color: #1D2129;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
    margin-left: 12px;
    &:hover{
      background: rgba(22, 93, 255, 0.1);
    }
    &:active{
      color: #0E42D2;
      background: rgba(14, 66, 210, 0.1);
      border: 1px	solid rgb(14, 66, 210);
    }
  }
  .export-btn{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    // width: 90px;
    width: fit-content;
    padding: 0 16px;
    height: 28px !important;
    line-height: 28px !important;
    text-align: center;
    background: #fff;
    border: 1px	solid#C9CDD4;
    color: #1D2129;
    border-radius: 6px;
    font-size: 12px;
    cursor: pointer;
    margin-bottom: 8px;
    margin-top: 6px;
  }
}
.el-table--border::after, .el-table--group::after, .el-table::before{
  background-color:#e5e6eb !important;
}
</style>